module.exports = __webpack_public_path__ + "static/media/Menu.4bc2a4e3.svg";